import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import {
    formatAuraDateLabel,
    formatAuraMetric,
    formatAuraStructuredTableValue,
} from '@/utils/auraPresentation';
import { getAuraChartColor } from '@/utils/auraChartPalette';

interface Props {
    labels: string[];
    data: unknown[];
    columns?: string[];
    tableRows?: Array<Record<string, unknown>>;
    unit?: string;
    selectedLabel?: string | null;
}

const rowsPerPage = 25;


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraChartTable',
  props: {
    labels: { type: Array, required: true },
    data: { type: Array, required: true },
    columns: { type: Array, required: false },
    tableRows: { type: Array, required: false },
    unit: { type: String, required: false },
    selectedLabel: { type: [String, null], required: false }
  },
  emits: ["select"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const emit = __emit;
const activeLabel = ref<string | null>(null);
const currentPage = ref(1);
const isStructuredTable = computed(
    () => props.columns?.length && props.tableRows && props.tableRows.length > 0,
);
const structuredRows = computed(() => (isStructuredTable.value ? props.tableRows || [] : []));
const totalPages = computed(() =>
    Math.max(1, Math.ceil(structuredRows.value.length / rowsPerPage)),
);
const paginatedStructuredRows = computed(() => {
    const start = (currentPage.value - 1) * rowsPerPage;
    return structuredRows.value.slice(start, start + rowsPerPage);
});

watch(
    [structuredRows, totalPages],
    () => {
        if (currentPage.value > totalPages.value) currentPage.value = totalPages.value;
    },
    { immediate: true },
);

const rows = computed(() => {
    const numericValues = props.data.map((value) => (typeof value === 'number' ? value : 0));
    const total = numericValues.reduce((sum, value) => sum + Math.max(value, 0), 0);

    return props.labels.map((label, index) => {
        const rawValue = props.data[index];
        const value = typeof rawValue === 'number' || typeof rawValue === 'string' ? rawValue : '-';
        const numericValue = typeof rawValue === 'number' ? Math.max(rawValue, 0) : null;
        return {
            label,
            color: getAuraChartColor(index),
            value: formatAuraMetric(value, props.unit),
            percentage: numericValue !== null && total > 0 ? (numericValue / total) * 100 : null,
        };
    });
});

const selectAndActivate = (row: (typeof rows.value)[number]) => {
    activeLabel.value = row.label;
};

const selectRow = (row: (typeof rows.value)[number]) => {
    activeLabel.value = row.label;
    emit('select', row.label);
};

const formatColumnLabel = (column: string) => {
    const labels: Record<string, string> = {
        dispositivo: 'Dispositivo',
        fila: 'Fila',
        quantidade_de_usuarios: 'Quantidade de usuários',
        ramal: 'Ramal',
        usuario: 'Usuário',
    };
    return labels[column] || column.replaceAll('_', ' ');
};

const __returned__ = { props, emit, activeLabel, currentPage, rowsPerPage, isStructuredTable, structuredRows, totalPages, paginatedStructuredRows, rows, selectAndActivate, selectRow, formatColumnLabel, get formatAuraDateLabel() { return formatAuraDateLabel }, get formatAuraStructuredTableValue() { return formatAuraStructuredTableValue } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})